module.exports = __webpack_public_path__ + "static/media/Step4.7f4c48ef.jpg";